var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.moduleData),function(list){return _c('el-tag',{key:list.tag_id,staticClass:"mr-1 mb-1",attrs:{"type":"primary","effect":"plain"}},[_vm._v(_vm._s(list.tag_name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }